import StringUtils from './StringUtils';

class ObjectUtils {
    static getPropertyByString(object, propertyPath) {
        propertyPath = propertyPath.replace(/\[(\w+)\]/g, '.$1');
        propertyPath = propertyPath.replace(/^\./, '');
        var a = propertyPath.split('.');
        for (var i = 0, n = a.length; i < n; ++i) {
            var k = a[i];
            if (k in object) {
                object = object[k];
            } else {
                return;
            }
        }
        return object;
    }

    static includesNotBlankProperty(object) {
        if (!object) {
            return false;
        }

        for (let key in object) {
            if (StringUtils.isNotBlank(object[key])) {
                return true;
            }
        }

        return false;
    }

    static objectSortingByValue(object){
        let sortable = [];

        for(let key in object){
            sortable.push([key, object[key]]);
        }

        sortable = sortable.sort((a,b) => {
            if(a[1] < b[1]) return -1;
            if(a[1] > b[1]) return 1;
            return 0;
        });

        let objectSorted = {};
        sortable.forEach((item) => {
            objectSorted[item[0]]=item[1];
        });

        return objectSorted;
    }
}

export default ObjectUtils;